module.exports = __webpack_public_path__ + "static/media/header_cart_icon_white.f1bc9bf6.svg";